import {useEffect} from 'react'
import ConfigurationHeader from './components/configurationHeader';
import './configuration.scss'
import {useAppSelector} from "../../../Redux/hooks";
import Hooks from "./utils/hooks";
import ConfigurationData from './components/configurationData';
import DisplayAlert from './components/Alert';
import {Grid} from "@material-ui/core";
import { Loader } from '@empreinte/components.loader';


const Configuration = () => {
    const {getListChannel, onFinishAddConfiguration, onValueFormUserchangeConfiguration  } = Hooks()
    const loader = useAppSelector((state)=>state.ConfigurationReducer.isLoading)
    useEffect(() => {   
        getListChannel()   
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [])
  

    return (
        <div className={"divGlobalTable"}>
            <DisplayAlert/>
                    <div>
                    <Loader isOpen={loader}/>
                    <Grid
                           onSubmit={onFinishAddConfiguration}
                            onChange={onValueFormUserchangeConfiguration}

                        >
                        <ConfigurationHeader/>
                      
                      <ConfigurationData/>
                      </Grid>
                    </div>

                   
        </div>
    )
}

export default Configuration
